export default {
  //授课班级小组
  SKGroupList: '',
  //授课班级小组学生
  SKGroupStuList: '',
  // 授课全班学生信息
  SKAllClassStuList: '',
  //授课课堂得分增加
  SKScoreStu: '',
  //授课课堂得分选项列表
  SKScoreOptList: '',
  //授课班级全班学生
  SKClassStuList: '',
  //授课班级获取目录
  SKCatalogList: '',
  //授课课中活动记录
  SKActivityRecordAdd: '',
}
